import { AlertType } from "/src/models/Alert";
import { LocationType, Location } from "/src/models/Location";
import dayjs from "dayjs";

export const getLocationKey = ({
  imei,
  locationType,
  alertType,
  eventDate,
}: {
  imei: string;
  locationType: LocationType;
  alertType?: AlertType;
  eventDate: string;
}) => `${imei}___${locationType}__${alertType ?? ""}__${eventDate}`;

export const parseLocationKey = (key: string) => {
  const keys = key.split("__");
  return {
    imei: keys[0],
    locationType: keys[1],
    alertType: keys[2] as AlertType | "",
    eventDate: keys[3],
  };
};

export const locationsEqual = (a: Location[], b: Location[]) => {
  if (a.length != b.length) {
    return false;
  }

  const sortedA = a.sort((a1, b1) => (a1.key > b1.key ? 1 : -1));
  const sortedB = b.sort((a1, b1) => (a1.key > b1.key ? 1 : -1));

  for (let i = 0; i < sortedA.length; i++) {
    if (sortedA[i].key != sortedB[i].key) {
      return false;
    }
  }

  return true;
};

export function getElapsed(dateStr: string, noYear = false): string {
  const now_utc = new Date();
  const event = new Date(Date.parse(dateStr));

  const minutesSince = (now_utc.getTime() - event.getTime()) / 1000 / 60;

  if (minutesSince < 1 && false) {
    //within 1 min
    return "<1m";
  } else if (minutesSince >= 1 && minutesSince < 59 && false) {
    //within 1 hour
    return minutesSince.toFixed(0) + "m";
  } else if (minutesSince >= 59 && minutesSince < 1440 && false) {
    //within 1 day
    return ">" + (minutesSince / 60).toFixed(0) + "h";
  } else {
    return dayjs(event).format(noYear ? "DD/MM HH:mm" : "DD/MM/YYYY HH:mm");
  }
}

export function parseJwt(token: string) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(""),
  );

  return JSON.parse(jsonPayload);
}

export function isValidIsHomeLocation(input: Location) {
  return input.is_home && input.lbs === 5; // lbs=5 means Pannovation resolver
}

export const transformLocationAccuracy = (input: Location) => {
  input.lng = input.lon;
  if (input.valid) {
    return { ...input, accuracy: 30 } as Location;
  }
  if (isValidIsHomeLocation(input)) {
    return { ...input, accuracy: 90 } as Location;
  }
  return input;
};
